module.exports = __webpack_public_path__ + "media/Yipi_MueveMexico.44ef20b7.webm";